define('SageDotCom/DataLayer/Events/product-card-tertiary-button',[
    'SageDotCom/DataLayer/Events/eventBase'
], function (EventBase) {

    function ProductCardTertiaryButtonEvent(el, eventName, eventAction) {
        EventBase.call(this);

        var product = JSON.parse(el.dataset.tracking);

        this.props = {
            'event_name': eventName || "product_button_click",
            'event_non-int': "0",
            'event_category': "ecommerce",
            'event_action': eventAction || "product_button_click",
            'event_label': product.title,
            'event_name_level_1': this.getId(el),
            'event_name_level_2': product.category,
            'event_name_level_3': product.price,
            'event_name_level_4': product.sku
        };
    }

    ProductCardTertiaryButtonEvent.prototype = Object.create(EventBase.prototype);

    return ProductCardTertiaryButtonEvent;
});
